import { getters } from '@/modules/core/app/helpers/store';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { AppFeature } from '@/modules/core/app/constants/app.constants';

export class ClientGroupRouteConfig extends PageRouteConfig {
  /**
   * Any contextual permissions based on route
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    return (
      getters.session.getUserSettings()?.isFeatureAvailable(AppFeature.CLIENT_GROUPS) &&
      super.canAccessRouteFromContext()
    );
  }
}
